<template>
  <div v-if="plate">
    <div>
      {{ lead.firstname }}, what I'll do for you is work with and underwriter to
      get you medically support approved. If you qualify, you'll receive a
      physical copy of your policy in the mail. As-well as emailed.
    </div>

    <h4>Verify your:</h4>

    <!--    Todo find other data    -->

    <div class="d-flex align-center">
      <v-checkbox
        v-model="plate.isEmailAsked"
        :error="$v.plate.isEmailAsked.$error"
        label="Email address:"
      />
      <v-text-field
        v-model="currentLead.email"
        :error="$v.currentLead.email.$error"
        hide-details
        class="input-small ml-6"
        placeholder="Email"
      />
    </div>

    <div class="d-flex align-center">
      <v-checkbox
        v-model="plate.isAddressAsked"
        :error="$v.plate.isAddressAsked.$error"
        label="Home address:"
      />
      <v-text-field
        hide-details
        class="input-small ml-6"
        placeholder="Home"
        v-model="plate.address"
      />
    </div>

    <div class="d-flex align-center">
      <v-checkbox
        v-model="plate.isPhysicianAsked"
        :error="$v.plate.isPhysicianAsked.$error"
        label="Who's your Primary care physician:"
      />
      <v-text-field
        hide-details
        class="input-small ml-6"
        placeholder="Physician"
        v-model="plate.physician"
      />
    </div>

    <div class="d-flex align-center">
      <v-checkbox
        v-model="plate.isSocialAsked"
        :error="$v.plate.isSocialAsked.$error"
        label="What's your social:"
      />
      <v-text-field
        hide-details
        class="input-small ml-6"
        placeholder="Social"
        v-model="plate.social"
      />
    </div>

    <PlateFooter
      :onBack="onBack"
      :onSubmit="onSubmit"
      :isLoading="isLoading"
      :errors="$v.$error"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PlateFooter from '@/components/lead/plates/PlateFooter';
import { PlatesSteps } from '@/common/variables';
import { isChecked } from '@/common/helpers';
import { email } from 'vuelidate/lib/validators';

export default {
  name: 'EmailPlate',
  components: { PlateFooter },
  props: {
    lead: {
      type: Object,
    },
    beneficiary: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({ needs: 'plates/needs' }),
  },
  data: () => ({
    plate: null,
    isLoading: false,
    currentLead: {},
  }),
  mounted() {
    const { data } = this.$store.getters['plates/dataByStep'](
      PlatesSteps.email
    );
    this.plate = data;
    Object.assign(this.currentLead, this.lead);
  },
  methods: {
    onBack() {
      this.$store.commit('plates/setStep', PlatesSteps.result);
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.commit('plates/setStep', PlatesSteps.beneficiary);
      this.$store.dispatch('plates/updatePlate', this.lead);
    },
  },
  validations: {
    plate: {
      isEmailAsked: { checked: isChecked },
      isAddressAsked: { checked: isChecked },
      isPhysicianAsked: { checked: isChecked },
      isSocialAsked: { checked: isChecked },
    },
    currentLead: {
      email: { email },
    },
  },
};
</script>

<style scoped lang="scss">
.input-small {
  max-width: 280px;
}
</style>